

































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters} from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import MultiSelect from 'vue-multiselect';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import ProjectsData from '@/ts/ProjectsData';
import BuildingData from '@/ts/BuildingData';
import PropertyData from '@/ts/PropertyData';
import cloneDeep from 'lodash/cloneDeep';
import difference from 'lodash/difference';

@Component({
    components: {
        ConfirmPopup,
        MultiSelect,
    },
    computed: {
        ...mapGetters({
            groupingTypes: 'Groupings/getGroupingTypes',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})
export default class EditGrouping extends Mixins(InputFieldMethods, DateMethods, NotifyMethods) {
    public initialUnitIds: number[] = [];

    constructor() {
        super();
    }

    get newUnits() {
        return difference(this.grouping.unitIds, this.initialUnitIds).length;
    }

    get removedUnits() {
        return difference(this.initialUnitIds, this.grouping.unitIds).length;
    }

    get grouping() {
        return this.$store.getters['Groupings/getCurrentGrouping'];
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    get buildings(): BuildingData[] {
        return !this.grouping.projects.length
            ? []
            : this.$store.getters['Buildings/projectsBuildings'](this.grouping.projects.map((project) => project.id));
    }

    get properties(): PropertyData[] {
        if (this.grouping.buildings.length) {
            return this.$store.getters['Properties/buildingsProperties'](this.grouping.buildings.map((building) => building.id));
        }

        if (this.grouping.projects.length) {
            return this.$store.getters['Properties/projectsProperties'](this.grouping.projects.map((project) => project.id));
        }

        return [];
    }

    public selectProject() {
        this.grouping.buildings = [];
    }

    public checkOrUncheckAllUnits(ev) {
        this.grouping.unitIds = ev.srcElement.checked ? this.properties.map((unit: any) => unit.id) : [];
    }

    public setGroupingUnits(ev: any, unitId: number) {
        if (ev.srcElement.checked) {
            this.grouping.unitIds.push(unitId);
        } else {
            this.grouping.unitIds = this.grouping.unitIds.filter((unit: any) => {
                return unit !== unitId;
            });
        }
    }

    public cancel() {
        this.$store.commit(Mutations.SET_CURRENT_GROUPING, null);
        this.$router.push({ name: 'admin-groupings' });
    }

    public editGroupings() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                if (!this.grouping.unitIds.length) {
                    return this.notify('please_select_at_least_one_unit', 'warning');
                }

                const projectIds   = this.grouping.projects.map((project: any) => project.id);
                const unitGroupIds = this.grouping.buildings.map((unitGroup: any) => unitGroup.id);

                this.$store.dispatch(Actions.EDIT_GROUPING, {
                    groupingId: this.grouping.id,
                    groupingName: this.grouping.name,
                    groupingType: this.grouping.typeId,
                    unitIds: this.grouping.unitIds,
                });
            }
        });
    }

    public deleteGrouping(groupingId: number, groupingName: any): void {
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'Groupings/DELETE_GROUPING',
            confirmActionData: {groupingId, reload: true},
            confirmQuestionText: this.$t('are-you-sure-you-want-to-delete-this-grouping', 'Are you sure you want to delete this grouping?'),
            confirmInfoText: groupingName,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmIconVisibility: true,
            confirmIcon: 'fa-trash',
            confirmHeaderText: this.$t('general.delete-grouping', 'Delete grouping'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_GROUPING_TYPES);
        this.$store
            .dispatch(Actions.FETCH_CURRENT_GROUPING, { groupingId: this.$route.params.groupingId, action: 'edit' })
            .then(() => {
                 this.initialUnitIds = cloneDeep(this.grouping.unitIds);
            });
    }
}
